module.exports = __webpack_public_path__ + "media/application/images/logo_carre-2da393d51330c3fc2ad0c5d7231b7e60.png";